import { render, staticRenderFns } from "./media_catalog_add.vue?vue&type=template&id=4ea1df6a"
import script from "./media_catalog_add.vue?vue&type=script&lang=js"
export * from "./media_catalog_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports